module.exports = __webpack_public_path__ + "media/common/images/gasnet_white-5ce847cf5f46023a63de99bfef3b4e86.svg";